var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 32.0203C5.33325 17.2804 17.2806 5.33301 32.0205 5.33301C46.7537 5.34969 58.6911 17.2871 58.7078 32.0203C58.7078 46.7568 46.7604 58.7076 32.0205 58.7076C17.2806 58.7076 5.33325 46.7568 5.33325 32.0203ZM9.78057 32.0203C9.78057 44.3013 19.7395 54.2602 32.0205 54.2602C44.2982 54.2469 54.2471 44.2946 54.2605 32.0203C54.2605 19.7359 44.3015 9.78033 32.0205 9.78033C19.7395 9.78033 9.78057 19.7359 9.78057 32.0203ZM40.9147 22.011H44.251C46.7065 22.011 48.6983 24.0028 48.6983 26.4583V37.5783C48.6983 40.0338 46.7065 42.0256 44.251 42.0256H19.7891C17.3302 42.0256 15.3417 40.0338 15.3417 37.5783V26.4583C15.3417 24.0028 17.3302 22.011 19.7891 22.011H23.1254C23.5324 21.9743 23.9194 21.8141 24.2364 21.5506L27.1123 18.6747C27.8429 17.9941 28.7971 17.6004 29.7947 17.5637H34.242C35.2429 17.6004 36.1971 17.9941 36.9278 18.6747L39.8037 21.5506C40.1173 21.8141 40.5076 21.9743 40.9147 22.011ZM32.02 37.0211C34.7825 37.0211 37.0245 34.7824 37.0245 32.02C37.0245 29.2541 34.7825 27.0155 32.02 27.0155C29.2576 27.0155 27.0155 29.2541 27.0155 32.02C27.0155 34.7824 29.2576 37.0211 32.02 37.0211Z",
    fill: "#D64309"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.fde97ca7cc7d72d7fe2ba09d8d2e7beb.svg";
export { ForwardRef as ReactComponent };